// extracted by mini-css-extract-plugin
module.exports = {"top":"TermsConditions_top__kto1F","content":"TermsConditions_content__nSqug"};